import ReferencePathService from "~/services/referencePathServices/referencePathService";
import {ModelType} from "~/enums/modelType";
import {IReferencePathNodeCertificate, IReferencePathNodeSpecific} from "~/interfaces/referencePathInterfaces";
import {GenericType} from "~/interfaces/genericTypeInterfaces";
import Certificate from "../../../formability/certificateBuilder/models/certificate";

export default class CertificatePathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.Certificate;

  constructor(private certificateNode: IReferencePathNodeCertificate) {
    super();
  }

  get label(): string {
    return this.certificateNode.reference()?.title;
  }

  get nodes(): IReferencePathNodeCertificate[] {
    return [this.certificateNode];
  }

  reference(): Certificate {
    return Certificate.repo.findBy(cert => cert.id === this.certificateNode.reference_id);
  }

  get referenceGenericModelType(): GenericType {
    return this.reference()?.genericType;
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType;
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    const decision = this.reference().certificateDynamicInputsArrayDeep.some(i => i.id === node.reference_id);
    this.debugCanLinkTo('CertificatePathService', this.certificateNode, node, decision);
    return decision;
  }

  get referenceIsCollection(): boolean {
    return false;
  }

}